import styled from "styled-components";

export const StyledMainContainer = styled.div`

`;
export const StyledTextContainer = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-row-gap: 20px;
`;
export const StyledTitle = styled.div`
  font-family: "Gilroy", sans-serif;
  font-size: 20px;
  color: #264445;
  font-weight: bold;
`;
export const StyledDescription = styled.div`
  font-family: "Gilroy", sans-serif;
  font-size:14px;
  line-height: 21px;
  color: #797A80;
  font-weight: 400;
`;
export const StyledImageContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;


  img {
    max-width: 551px;
    max-height: 416px;
  }

  @media (max-width: 551px) {
    img {
      max-width: 360px;
      max-height: 416px;
    }
  }
`;